import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_BACK_ROUTE}/api/`,
});

export {
  api as default,
};
